import './Pdfviewer.module.css';

const Pdfviewer = (props) => {
  const data = props.data || props;
  if(!data) return null;
  
  return (
    <>
      <div className='container'>
        Pdfviewer
      </div>
    </>
  );
};

export default Pdfviewer;
